<template>
    <div class="automation-block-editor date-formatter-chain">
        <div class="editor-row customize-editor-minimize data-items">
            <div class="editor-row-title">{{ $t('auto.dateFormatChainNumberFormatChains') }}</div>
            <DateFormatItem
                v-model="clone.chains[index]"
                v-for="(item, index) in clone.chains"
                :key="index"
                @delete="() => deleteFormatter(index)"
                :blockId="blockId"
                :deleteEnabled="clone.chains.length > 1"
            />
        </div>
        <SupsisButton @click="addItem">
            <i class="material-icons">add</i>
            <span>{{ $t('auto.dateFormatChainAddNewFormatter') }}</span>
        </SupsisButton>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import SupsisButton from "../../../../../../Settings/components/SupsisButton.vue";
import DateFormatItem from "./DateFormatItem.vue";

const log = log2("DateFormatChain");
export default {
    name: "DateFormatChain",
    components: { DateFormatItem, SupsisButton },
    props: ["value", "blockId"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            chains: [],
        };
        return {
            clone,
        };
    },
    methods: {
        addItem() {
            const defaultPayload = {
                add: {
                    value: "1",
                    unit: "days",
                    fromFormat: "YYYY-MM-DD",
                    toFormat: "YYYY-MM-DD",
                    fromLocale: "en",
                    toLocale: "en",
                },
                sub: {
                    value: "1",
                    unit: "days",
                    fromFormat: "YYYY-MM-DD",
                    toFormat: "YYYY-MM-DD",
                    fromLocale: "en",
                    toLocale: "en",
                },
                format: {
                    fromFormat: "YYYY-MM-DD",
                    toFormat: "YYYY-MM-DD",
                    toTimezone: "UTC",
                    fromTimezone: "UTC",
                },
                compare: {
                    fromFormat: "YYYY-MM-DD",
                    toFormat: "YYYY-MM-DD",
                    checkPart: ["year", "month", "day", "hour", "minute", "second"],
                },
                startOf: {
                    unit: "day",
                    fromFormat: "YYYY-MM-DD",
                    toFormat: "YYYY-MM-DD",
                    timezone: "UTC",
                },
                endOf: {
                    unit: "day",
                    fromFormat: "YYYY-MM-DD",
                    toFormat: "YYYY-MM-DD",
                    timezone: "UTC",
                },
                diff: {
                    fromFormat: "YYYY-MM-DD",
                    toFormat: "YYYY-MM-DD",
                    unit: "days",
                },
            };
            this.clone.chains.push({
                mode: "date.add",
                inputs: [`{{block.${this.blockId}}}`, ""],
                ...defaultPayload,
            });
        },
        deleteFormatter(index) {
            this.clone.chains.splice(index, 1);
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.date-formatter-chain {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;
        border-bottom: 1px solid var(--color-border-default);

        &.customize-editor-minimize {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        small.description {
            font-size: 10px;
            color: var(--color-text-weak-default);
        }

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}
</style>
